import React, { useState, useEffect } from 'react';
import { getConsent, setConsent, onConsentChange, trackPageView, PIXEL_ID } from '../lib/metaPixel';

/* Cookie banner. Equal-weight Accept / Decline. Only shown when ad measurement
   (Meta Pixel) is configured and the member has not chosen yet. */
const ConsentBanner = () => {
  const [choice, setChoice] = useState(getConsent());

  useEffect(() => onConsentChange(() => setChoice(getConsent())), []);

  if (!PIXEL_ID || choice) return null;

  const decide = (value) => {
    setConsent(value);
    if (value === 'granted') trackPageView();
  };

  return (
    <div
      role="region"
      aria-label="Cookie preferences"
      className="fixed left-3 right-3 bottom-20 lg:bottom-4 lg:left-auto lg:right-4 lg:max-w-sm z-[60] glass-card rounded-arch-lg p-4 shadow-xl"
      data-testid="consent-banner"
    >
      <p className="text-sm text-text-main leading-relaxed">
        We use cookies to understand how Sirati is used and to measure our ads. You can accept or decline, and change your choice any time in our{' '}
        <a href="/privacy" className="text-primary underline underline-offset-2">Privacy Policy</a>.
      </p>
      <div className="flex gap-2 mt-3">
        <button
          type="button"
          onClick={() => decide('denied')}
          className="flex-1 min-h-[44px] rounded-full border border-primary/30 text-sm font-medium text-text-main hover:bg-primary/10"
          data-testid="consent-decline"
        >
          Decline
        </button>
        <button
          type="button"
          onClick={() => decide('granted')}
          className="flex-1 min-h-[44px] rounded-full bg-primary text-white text-sm font-medium hover:bg-primary/90"
          data-testid="consent-accept"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default ConsentBanner;
